import regexConstants from '@treasury/domain/shared/utilities/regex-constants.js';

angular.module('backOffice').constant('regexConstants', regexConstants);
